import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ResultImage from '../../../../../assets/images/resultImage.png';
import FailedImage from '../../../../../assets/images/failedimage.png';

function ExamResult() {
    const location = useLocation();
    const navigate = useNavigate();
    const { examResult } = location.state || {};

    if (!examResult) {
        return <div>No result found. Please try again.</div>;
    }

    const { 
        examName, 
        totalQuestions, 
        correctAnswers, 
        score
    } = examResult;

    const hasPassed = score > 0; 

    return (
        <div className='exam-result-box-center'>
            <h3 className='result-box-exam-name-heading'>{examName}</h3>
            <div className="exam-result-result-screen">
                <div className='exam-result-result-component'>
                    <h3 style={{ color: hasPassed ? '#2da44a' : 'red', marginBottom: '10px', fontWeight: '700' }}>
                        {hasPassed ? 'Examination Passed' : 'Examination Failed'}
                    </h3>
                    <img
                        src={hasPassed ? ResultImage : FailedImage}
                        className='exam-result-result-image'
                        alt={hasPassed ? "result exam" : "failed exam"}
                    />
                    <p className='exam-result-score'>Score:</p>
                    <p className='exam-result-score-show' style={{ color: hasPassed ? '#2da44a' : 'red' }}>
                        {correctAnswers}/{totalQuestions}
                    </p>
                
                    <div className='exam-result-return-btn'>
                        <button className='exam-result-return-dashboard' onClick={() => navigate('/user/dashboard')}>Return to Dashboard</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ExamResult;